import './componenteTablaDark.css'
export default function EmpleadoAsignadoComponenteTablaDark({ stro }) {
    return (
        <th className='textoBodyTablaDark'>
            <div className="d-flex align-items-center gap-2">
                <div className={ stro.empleadoAsignado ? "circleVioleta" : "" }></div>
                {stro.empleadoAsignado}
            </div>
        </th>
    );
}
